const ExpiredLicense = ()=>{
    return(<>
        <div style={{height:'100vh',display:'flex',alignItems: 'center',justifyContent: 'center'}}>
            <h1>Expired</h1>
        </div>
    </>)
}
export default ExpiredLicense;